<template>
  <div class="general-background" style="font-family: cerebriSansReg">
    <b-navbar variant="faded" style="background-color: black!important;">
      <img
        src="../../assets/img/logo_word_white.png"
        class="d-inline-block align-top"
        v-b-toggle.sidebar-1
        style="height: 35px; margin-right: auto; margin-left: auto;"
        alt="menu-icon"
      />
    </b-navbar>
    <div
      style="padding: 10px; max-width: 500px; text-align: center; margin-left: auto; margin-right: auto;"
    >
      <div style="margin-bottom: 30px;">
        This invitation was created by
        <span style="font-weight: bold;">{{ownerName}}</span>
      </div>
      <div style="text-align: left;">
        <div>
          <span style="font-weight: bold;">To:</span>
          {{visitName}}
        </div>
        <div>
          <span style="font-weight: bold;">Where:</span>
          {{where}}
        </div>
        <div>
          <span style="font-weight: bold;">When:</span>
          {{date}} at {{time}}
        </div>
      </div>
      <div style="margin-top: 30px;">Please save your QR, you will need it at the entrance</div>
      <hr />
      <qriously :value="qrCode" :size="windowWidth" />
      <!--
      <div
        style="text-align: center; font-family: cerebriSansBold; font-size: 30px; margin: 10px;"
      >{{name}}</div>
      <div v-for="(input, index) in formGoodFormat" :key="index">
        <template v-if="input.type == 'text'">
          <CustomFormGroup :label="input.name" :inputTag="index" @update-input="getTextInputData" />
        </template>
        <template v-if="input.type == 'boolean'">
          <div>{{ input.name }}</div>
          <b-form-select
            v-model="formGoodFormat[index].value"
            :options="booleanOptions"
            @change="selectBool(index)"
          ></b-form-select>
        </template>
      </div>
      <div style="text-align: center;">
        <div
          v-if="!everythingOK"
          style="font-style: italic; margin-top: 15px;"
        >Please fill in all required entry fields</div>
        <b-button
          v-if="everythingOK"
          @click="createResponseQR"
          variant="outline-info"
          style="margin-top: 15px;"
        >Create Response QR</b-button>
      </div>
      <b-modal id="responseQR" size="lg" hide-footer ref="responseQRRef">
        <template v-slot:modal-title>Response QR</template>
        <div style="text-align: center;">
          <qriously :value="qrCode" :size="windowWidth" />
        </div>
      </b-modal>
      -->
    </div>
  </div>
</template>

<script>
import CustomFormGroup from "../../components/CustomFormGroup.vue";

import Vue from "vue";
import VueQriously from "vue-qriously";
Vue.use(VueQriously);

export default {
  name: "RenderForm",
  components: {
    CustomFormGroup
  },
  data() {
    return {
      name: "",
      id: "",
      formGoodFormat: [],
      qrCode: "",
      windowWidth: 200,
      everythingOK: false,
      booleanOptions: [
        { value: null, text: "Select your answer" },
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" }
      ],
      ownerName: "",
      date: "",
      where: "",
      time: null,
      visitName: "",
      pre: ""
    };
  },
  methods: {
    selectBool(index) {
      if (this.formGoodFormat[index].value != null) {
        this.formGoodFormat[index].state = true;
      } else this.formGoodFormat[index].state = false;
      this.checkAllStates();
    },
    checkAllStates() {
      // checks all states to allow button
      var generalState = true;
      for (let index = 0; index < this.formGoodFormat.length; index++) {
        const element = this.formGoodFormat[index];
        if (!element.state) {
          generalState = false;
          break;
        }
      }
      this.everythingOK = generalState;
    },
    createResponseQR() {
      var qrJSON = {
        id: this.id,
        visitName: this.visitName,
        qr: []
      };
      this.formGoodFormat.forEach(element => {
        var newElement = {};
        newElement.v = encodeURI(element.value);
        qrJSON.qr.push(newElement);
      });
      this.qrCode = JSON.stringify(qrJSON);
      this.$refs["responseQRRef"].show();
      console.log(this.qrCode);
    },
    getTextInputData(data) {
      this.formGoodFormat[data.index].value = data.value;
      this.formGoodFormat[data.index].state = data.state;
      this.checkAllStates();
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth - 20;
    if (this.windowWidth > 500) {
      this.windowWidth = 500;
    }
    // Decode url to create Form
    var query = this.$route.query;
    this.id = query.id;
    var qrJSON = {
        id: this.id,
        visitName: encodeURI(this.visitName)
      };
    this.qrCode = JSON.stringify(qrJSON);
    this.name = query.na;
    this.ownerName = query.o;
    this.date = query.d;
    this.where = query.w;
    this.time = query.tt;
    this.visitName = query.vn;
    this.pre = query.m;
    /*
    query.n.forEach((element, index) => {
      var tempDocument = {};
      tempDocument.value = "";
      tempDocument.state = null;
      tempDocument.name = element;
      switch (query.t[index]) {
        case "1":
          tempDocument.type = "text";
          break;
        case "2":
          tempDocument.type = "boolean";
          tempDocument.value = null;

          break;
        case "3":
          tempDocument.type = "options";
          break;
      }
      this.formGoodFormat.push(tempDocument);
    });
    */
  }
};
</script>
<style scoped>
@font-face {
  font-family: cerebriSansBold;
  src: url("../../assets/fonts/Cerebri-Sans/CerebriSans-Bold.ttf");
}
@font-face {
  font-family: cerebriSansReg;
  src: url("../../assets/fonts/Cerebri-Sans/CerebriSans-Regular.ttf");
}

.general-background {
  background-color: #f9fbfd;
  height: 100%;
  width: 100%;
}
</style>